<gea-shop-wagtail-page [cmsPageId]="1313"></gea-shop-wagtail-page>